import {Component} from "../../../gvf/js/component";
import {UtilsService} from "../../js/utils-service";

export class ModalFormButton extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        this.$root.click(
            (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$root.addClass("is-loading");
                UtilsService.createFormModal({
                    formEndpoint: $(ev.currentTarget).data("form-endpoint"),
                    saveEndpoint: $(ev.currentTarget).data("save-endpoint"),
                    formEndpointParams: $(ev.currentTarget).data("form-params"),
                    size: $(ev.currentTarget).data("modal-size"),
                    title: $(ev.currentTarget).data("modal-title"),
                    readyCallback: ()=>{
                        this.$root.removeClass("is-loading");
                    },
                    errorCallback: ()=>{
                        this.$root.removeClass("is-loading");
                    },
                    confirmCallback: (resp)=>{
                        if(resp.message){
                            UtilsService.alertEndpointResponse(resp);
                        }

                        if(resp.url){
                            window.location = resp.url;
                        }else{
                            this.$root.trigger("modalFormButton:confirmed",resp);
                        }
                    }
                });
            }
        );
    }
}

